import React, { useCallback, useMemo } from 'react';
import Tree from 'rc-tree';
import 'rc-tree/assets/index.less';
import { useAST, traverseUpdateTree, isContainerNode, useCurrentTeaId, useCurrentTeaAction, useASTDispatchAction, getNextPath, resetPathLastIndex, } from '@saucerjs/core';
export var TreeView = React.memo(function (props) {
    var ast = useAST();
    var currentSelectedTeaId = useCurrentTeaId();
    var setCurrentTeaId = useCurrentTeaAction().setCurrentTeaId;
    var dispatchMoveNodeByPath = useASTDispatchAction().dispatchMoveNodeByPath;
    var selectedKeys = useMemo(function () {
        if (currentSelectedTeaId === null) {
            return [];
        }
        return [currentSelectedTeaId];
    }, [currentSelectedTeaId]);
    var treeData = useMemo(function () { return [
        traverseUpdateTree(ast, function (node, _a) {
            var path = _a.path;
            if (isContainerNode(node)) {
                return {
                    key: node.id,
                    title: node.cupName + "(" + node.id + ")",
                    path: path,
                    children: node.children,
                };
            }
            else {
                return {
                    key: node.id,
                    title: node.cupName + "(" + node.id + ")",
                    path: path,
                };
            }
        }),
    ]; }, [ast]);
    var handleSelect = useCallback(function (selectedKeys) {
        if (typeof selectedKeys[0] === 'string') {
            setCurrentTeaId(selectedKeys[0]);
        }
        else {
            setCurrentTeaId(null);
        }
    }, [setCurrentTeaId]);
    var handleDrop = function (info) {
        var dragNode = info.dragNode;
        var node = info.node;
        var dropToGap = info.dropToGap, dropPosition = info.dropPosition;
        if (Array.isArray(node.children) && dropToGap === false) {
            // Drop into container
            var targetPath = node.path + ".0";
            if (node.path === '') {
                targetPath = '0';
            }
            dispatchMoveNodeByPath(dragNode.path, targetPath);
            return;
        }
        if (dropToGap === true) {
            dispatchMoveNodeByPath(dragNode.path, resetPathLastIndex(node.path, dropPosition));
            return;
        }
        if (node.dragOverGapTop === true) {
            dispatchMoveNodeByPath(dragNode.path, node.path);
        }
        else if (node.dragOver === true || node.dragOverGapBottom === true) {
            dispatchMoveNodeByPath(dragNode.path, getNextPath(node.path));
        }
    };
    return (React.createElement("div", { className: "saucer-editor-treeview", style: props.style },
        React.createElement(Tree, { defaultExpandAll: true, showIcon: false, selectedKeys: selectedKeys, treeData: treeData, draggable: true, onSelect: handleSelect, onDrop: handleDrop })));
});
TreeView.displayName = 'TreeView';
